/**
 * Library/picker ordering (frontend-only). Pure — unit-testable.
 *
 * Rules:
 *  - Parts of the same group (parent_doc_id) always sit TOGETHER, ordered by
 *    chunk_index asc inside the group.
 *  - The group is ANCHORED at the chronological position of its OLDEST part
 *    (created_at of the first processed part): processing new parts does NOT move
 *    the group in the list — new parts slot in under part 1.
 *  - Ungrouped docs keep the usual newest-first chronological order.
 *
 * created_at is an ISO-8601 string → lexicographic comparison is chronological.
 */
export function sortLibraryDocs(docs) {
  // Anchor per group = oldest created_at among its visible parts.
  const anchors = {};
  for (const d of docs) {
    if (!d.parent_doc_id) continue;
    const ts = d.created_at || '';
    if (!(d.parent_doc_id in anchors) || ts < anchors[d.parent_doc_id]) {
      anchors[d.parent_doc_id] = ts;
    }
  }
  return [...docs].sort((a, b) => {
    const ka = a.parent_doc_id ? anchors[a.parent_doc_id] : (a.created_at || '');
    const kb = b.parent_doc_id ? anchors[b.parent_doc_id] : (b.created_at || '');
    if (ka !== kb) return ka < kb ? 1 : -1; // newest anchor first
    // Same anchor: same group → chunk order; tie between distinct docs → stable.
    if (a.parent_doc_id && a.parent_doc_id === b.parent_doc_id) {
      return (a.chunk_index || 0) - (b.chunk_index || 0);
    }
    return 0;
  });
}
